import { render, staticRenderFns } from "./LimitSelect.vue?vue&type=template&id=491885ca&scoped=true&"
import script from "./LimitSelect.vue?vue&type=script&lang=js&"
export * from "./LimitSelect.vue?vue&type=script&lang=js&"
import style0 from "./LimitSelect.vue?vue&type=style&index=0&id=491885ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491885ca",
  null
  
)

export default component.exports